import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {FiAlertCircle} from "react-icons/fi";

const LogoutPopup = () => {
	const [show, setShow] = useState(false);
    const [popupStatus, setPopupStatus] = useState<any>(false);
    
    useEffect(() => {
        if(localStorage.getItem("forcedLogout") === "true") {
            setShow(true);
            setPopupStatus(true);
        }
    }, []);

    const handleClose = () => {
        localStorage.setItem("forcedLogout", "false");
        setShow(false);
        setPopupStatus(false);
    }

    return (
        <React.Fragment>
            {(popupStatus) &&
				<Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false} centered>
					<Modal.Body>
						<div className='row'>
							<div className='col-12'>
								<div className='incomming-box text-center'>
									<div className='incomming-call-icon text-danger'><FiAlertCircle /></div>
									<h6 className='mt-3 mb-0 text-darkblue'>It seems like you didn't set your status to Offline before leaving the CCP. Please make sure to do so next time!</h6>
                                    <hr />
                                    <Button onClick={() => { handleClose() }} className='mw-100 me-2' variant="primary">
                                        OK, I agree
                                    </Button>
                                </div>                    
							</div>
						</div>
					</Modal.Body>
				</Modal>
			}
        </React.Fragment>
    )
}
export default LogoutPopup;